import { SubAPI } from "./SubAPI";
export class Debug extends SubAPI {
    submit(input) { return this.fetcher.postFormData("/api/debug/submit-log", input); }
}
